import { setSettings, setFound } from "../../Redux/DownloadSlice/downloadSlice";
import { sendGetCallToSever, sendPostCallToSever } from "../Axios/Axios";
import type { AppDispatch } from "../../Redux/store";

interface SaveSettingsParams {
  Format: number | string;
  Resolution: number | string;
  Quality: number;
}

const SaveSettings = (
  downloadState: SaveSettingsParams,
  uploaded: () => void
) => (dispatch: AppDispatch) => {
  let preserve_format: boolean, format: number | string, Preserveresolution: boolean, resolution: string;
  if (downloadState.Format === 0) {
    preserve_format = true;
    format = "";
  } else {
    preserve_format = false;
    format = downloadState.Format;
  }
  if (Number(downloadState.Resolution) === 0 || downloadState.Resolution === "") {
    Preserveresolution = true;
    resolution = "";
  } else {
    Preserveresolution = false;
    resolution = parseInt(String(downloadState.Resolution)).toString();
  }
  const payload = {
    preserveFormat: preserve_format,
    format: format,
    maintainResolution: Preserveresolution,
    resolution: resolution,
    quality: downloadState.Quality,
  };

  // SEND CALL TO SERVER TO LOGIN FROM PUNCH
  return sendPostCallToSever(payload, "setting").then(() => {
    dispatch(setFound(true));
    uploaded();
  });
};
const GetSettings = () => (dispatch: AppDispatch) => {
  return sendGetCallToSever("setting").then((result) => {
    const data = ((result.data as { data?: unknown }).data ?? result.data) as {
      preserveFormat?: boolean;
      format?: number;
      maintainResolution?: boolean;
      resolution?: string;
      quality?: number;
    };
    const Format = data.preserveFormat ? 0 : data.format;
    const Resolution = data.maintainResolution ? 0 : parseInt(String(data.resolution || 0));
    const Quality = data.quality ?? 90;

    dispatch(
      setSettings({
        Format: Format ?? 0,
        Resolution: String(Resolution),
        Quality: Quality ?? 90,
        Found: true,
      }),
    );
  });
};

export { SaveSettings, GetSettings };
